import { PointOfSaleSettings } from '../models/pointOfSaleSettings';
import * as MutationTypes from '../mutationTypes';
import * as api from '@pointOfSale/api';

export const pointOfSaleSettingsRequest = async ({ commit, getters: { pointOfSaleSettings, selectedPointOfSale } }, pointOfSaleGuid) => {
  if (!pointOfSaleSettings && selectedPointOfSale?.isManaged) {
    const response = await api.pointOfSaleSettingsRequest(pointOfSaleGuid);
    const pointOfSaleSettingsRes = PointOfSaleSettings.toInstance(response.data);
    commit(MutationTypes.POINT_OF_SALE_SETTINGS_SUCCESS, pointOfSaleSettingsRes);
  } else {
    // If it's not a managed point of sale, use default settings as a fallback
    commit(MutationTypes.POINT_OF_SALE_SETTINGS_SUCCESS,
      new PointOfSaleSettings(null, selectedPointOfSale.guid));
  }
};
